import gql from 'graphql-tag';

const WDT_CLASSROOM_ERRORS_BY_STUDENTS_QUERY = gql`
  query wdtClassroomErrorsByStudentsReport(
    $where: WdtClassroomErrorsByStudentsReportWhereInput!
    $dateRange: DateRangeInput
  ) {
    wdtClassroomErrorsByStudentsReport(where: $where, dateRange: $dateRange) {
      classroomId
      studentErrors {
        student {
          id
          firstName
          lastName
          gradeLevel
          __typename
        }
        errors {
          type
          count
        }
      }
    }
  }
`;

export default WDT_CLASSROOM_ERRORS_BY_STUDENTS_QUERY;
